export default __webpack_public_path__ + "static/media/logo_delta.586e9fd3.svg";